import { NURSE_COPY } from './nurseCopy';

/** Chemins portail infirmier — base configurable (nurse / major). */

export const NURSE_BASE = '/nurse';

export function createNursingPortalPaths(base) {
  return {
    DASHBOARD: base,
    ACCUEIL_ADHERENT: `${base}/accueil`,
    FILE: `${base}/file`,
    CONSULTATIONS: `${base}/file`,
    CONSULTATION_NEW: `${base}/consultations/new`,
    PARAMETRAGE: `${base}/file`,
    HISTORIQUE_PASSAGES: `${base}/historique-passages`,
    PHARMACY_LOCAL: `${base}/pharmacie`,
    GUIDE: `${base}/aide`
  };
}

export const NURSE_PATHS = createNursingPortalPaths(NURSE_BASE);

export function nursingFilePath(paths, filterId = 'all') {
  if (!filterId || filterId === 'all') return paths.FILE;
  return `${paths.FILE}?filter=${encodeURIComponent(filterId)}`;
}

export function nurseFilePath(filterId = 'all') {
  return nursingFilePath(NURSE_PATHS, filterId);
}

export function nursingConsultationEditPath(paths, consultationId, { section } = {}) {
  const basePath = paths.DASHBOARD.replace(/\/$/, '');
  const base = `${basePath}/consultations/${encodeURIComponent(String(consultationId))}/edit`;
  if (!section) return base;
  return `${base}?section=${encodeURIComponent(section)}`;
}

export function nurseConsultationEditPath(consultationId, { section } = {}) {
  return nursingConsultationEditPath(NURSE_PATHS, consultationId, { section });
}

/** Menu latéral opérationnel infirmier. */
export function getNursingNavItems(paths, navCopy, { showLocalPharmacy = false, extraItems = [] } = {}) {
  const NAV = navCopy?.NAV || NURSE_COPY.NAV;
  const operational = [
    { to: paths.DASHBOARD, end: true, icon: 'home', ...NAV.dashboard },
    { to: paths.ACCUEIL_ADHERENT, end: false, icon: 'users', ...NAV.accueil },
    { to: paths.FILE, end: false, icon: 'stethoscope', ...NAV.file },
    { to: paths.HISTORIQUE_PASSAGES, end: false, icon: 'history', ...NAV.historique },
    showLocalPharmacy
      ? { to: paths.PHARMACY_LOCAL, end: false, icon: 'pills', ...NAV.pharmacie }
      : null
  ].filter(Boolean);

  const aideItem = { to: paths.GUIDE, end: false, icon: 'question', ...NAV.aide };

  return [...operational, ...extraItems, aideItem];
}

export function getNurseNavItems(options = {}) {
  return getNursingNavItems(NURSE_PATHS, NURSE_COPY, options);
}
